// extracted by mini-css-extract-plugin
module.exports = {"media":"MediaResolver_media__cNM13","videoWrapper":"MediaResolver_videoWrapper__Cm7F5"};